import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#0d0914] flex items-center justify-center px-6" data-testid="payment-cancel-page">
      <div className="max-w-md w-full bg-[#140b22] border border-[#3b126d] rounded-2xl p-10 text-center shadow-xl">
        <XCircle className="w-14 h-14 text-[#e879f9] mx-auto mb-4" />
        <h1 className="f-poster text-3xl uppercase text-white mb-3" data-testid="payment-cancelled-title">Pago Cancelado</h1>
        <p className="text-sm text-[#d8b4fe] leading-relaxed mb-6">
          No se ha realizado ningún cargo. Si fue un error, puedes volver a intentarlo desde el enlace de pago que recibiste por email.
        </p>
        <Link to="/" className="f-poster uppercase text-xs tracking-wide border border-[#581c87] text-white px-6 py-3 rounded hover:border-[#e879f9] transition-colors inline-block" data-testid="cancel-home-link">
          Volver a ELADPENTESTER
        </Link>
      </div>
    </div>
  );
}
